import React from 'react'
import { NUMBER_OF_LESSONS } from '@mc/constants'
import { StyledFeatureVariable } from '@mc/feature-variables'
import { useTranslation, withI18nContext } from '@mc/i18n'
import { i18nInstance } from '../../i18n/i18nInstance'
import { PROMO_I18N_NAMESPACE, PROMO_FEATURE_FLAG } from '../../lib/constants'

interface GiftHeroProps {
  titleClassName?: string
}

const GiftHeroComp = ({
  titleClassName = 'mc-text-h1 mc-mb-2',
}: GiftHeroProps) => {
  const { t } = useTranslation(PROMO_I18N_NAMESPACE)

  return (
    <>
      <h1 className={titleClassName}>
        <StyledFeatureVariable
          flagName={PROMO_FEATURE_FLAG}
          variableName='gift_page.hero_title'
          defaultCopy={t('common.gift.hero.title')}
        />
      </h1>
      <p className='mc-text-large mc-opacity--muted mc-mb-8'>
        <StyledFeatureVariable
          flagName={PROMO_FEATURE_FLAG}
          variableName='gift_page.hero_subtitle'
          defaultCopy={t('common.gift.hero.subtitle', {
            numberOfLessons: NUMBER_OF_LESSONS,
          })}
        />
      </p>
    </>
  )
}

export const GiftHero = withI18nContext(i18nInstance)(GiftHeroComp)
